// import Request from '../utils/request';
import Request from '@/api/request';
// eslint-disable-next-line import/no-extraneous-dependencies
import qs from 'qs';
import Storage from '../utils/storage';
import DateUtil from '../utils/date';
import Native from '../utils/nativeProxy';
import Cookie from '../utils/cookie';
import appConst from '../const/app.const';

export default class commonService {
  /**
   *
   * @param {*} code
   * @param {*} scope
   */
  static getWeixinUserInfo({
    wechatCode,
    wechatRefreshToken,
  }) {
    return Request.post({
      action: 'hitch.market.wechat.userInfo',
      wechatCode,
      wechatRefreshToken,
    }).then((res) => {
      const responseData = res.data;
      if (responseData) {
        const { token, refreshToken, openid } = responseData;
        if (token && refreshToken && openid) {
          const expirationDate = DateUtil.startOfDay(DateUtil.addDay(new Date(), 30));
          Storage.setItem('wx_refresh_access_token', refreshToken, expirationDate);
          Storage.setItem('wx_access_token', token, expirationDate);
          Storage.setItem('wx_openid', openid, expirationDate);
          return responseData;
        }
      }
      throw new Error('获取用户信息失败');
    }).catch((e) => Promise.reject(e.response.data.code));
  }

  /**
   * 获取微信授权用户的openid
   * @param 微信用户授权后的code
   */
  static getWeixinOpenId(code, scope = '') {
    const storageKey = `${scope}wx_open_id_`;
    return Request.post({
      action: 'user.account.getOpenId',
      code,
    }, { apiServer: 'https://api.ttbike.com.cn/api' }).then((response) => {
      const responseData = response.data;
      const wxOpenId = responseData.openid;
      if (wxOpenId) {
        const expirationDate = DateUtil.startOfDay(DateUtil.addDay(new Date(), 5));
        Storage.setItem(storageKey, wxOpenId, expirationDate);
        return wxOpenId;
      }
      throw new Error('获取openId失败');
    });
  }

  /**
   * 获取微信token
   * @param {string} wechatCode
   * @return { openid, token, refreshToken }
   */
  static getAccessToken({
    wechatCode,
    wxRefreshToken,
  }) {
    return Request.post({
      action: 'hellobike.wechat.auth.token',
      wechatCode,
      wechatToken: Storage.getItem('wx_access_token'),
      openid: Storage.getItem('wx_openid'),
      wechatRefreshToken: wxRefreshToken,
    }, null).then((res) => {
      const responseData = res.data;
      if (responseData) {
        const { token, refreshToken, openid } = responseData;
        if (token && refreshToken && openid) {
          const expirationDate = DateUtil.startOfDay(DateUtil.addDay(new Date(), 30));
          Storage.setItem('wx_refresh_access_token', refreshToken, expirationDate);
          Storage.setItem('wx_access_token', token, expirationDate);
          Storage.setItem('wx_openid', openid, expirationDate);
          return responseData;
        }
      }
      throw new Error('获取acessToken失败');
    }).catch((e) => Promise.reject(e.response.body.code));
  }

  static getWeiBoAccessToken(code) {
    return Request.post({
      action: 'user.account.getWeiboAccessToken',
      code,
      redirectUri: `https://${window.location.host}${window.location.pathname}#/activity/country-free-deposit`,
    }, null).then((response) => response.data);
  }

  /**
   * 验证OpenId是否有效
   * @param openId
   * @returns {*|Promise.<Boolean>}
   */
  static validateOpenId(openId) {
    return Request.post({
      action: 'user.account.validateWxUser',
      openId,
    }, { apiServer: 'https://api.ttbike.com.cn/api' }).then((response) => response.data === 1);
  }

  // 获取微信签名
  static getWeixinSign(url) {
    return Request.post({
      action: 'user.account.getSign',
      url,
      businessType: 6,
    }, { apiServer: 'https://api.hellobike.com/api' }).then((v) => v);
  }

  static getWeiBoSign(url) {
    return Request.post({
      action: 'user.account.getWeiboSign',
      url,
    });
  }

  static login(mobile, code, picCode, options = {}) {
    return Request.post({
      action: 'user.account.login',
      city: options.city,
      cityCode: options.cityCode,
      adCode: options.adCode,
      userInfoId: options.userInfoId,
      bikeNo: options.bikeNo,
      mobile,
      code,
      picCode,
    }, { apiServer: appConst.AUTH_API }).then((response) => {
      const loginResult = { mobile, ...response.data };
      Storage.setItem('login_result', loginResult); // 不过期
      Cookie.setItem('user_token', loginResult.token); // 不过期
      return loginResult;
    });
  }

  static getPicValidateCode(mobile) {
    return Request.post({
      action: 'user.account.imageCaptcha',
      mobile,
    }, { apiServer: appConst.AUTH_API }).then((res) => res.data);
  }

  static validatePicCode(mobile, capText, source) {
    return Request.post({
      action: 'user.account.sendCodeV2',
      mobile,
      capText,
      source,
      systemCode: 63,
    }, {
      apiServer: appConst.AUTH_API,
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      paramsSerializer: (data) => qs.stringify(data),
    }).then((res) => res.data);
  }

  static logout() {
    return Native.invalidToken();
  }

  /**
   *  查询用户实名信息
   *  https://yapi.hellobike.cn/project/3021/interface/api/87107
   * @param {*} userType
   */

  static getRealNameInfo(userType, journeyType) {
    return Request.post({
      action: 'com.hellobike.ecosafe.getUserInfo',
      userType,
      journeyType,
    }, null, true).then((r) => r.data);
  }
}
